import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Tag} from '../shared/Tag';
import {TagCategory} from '../shared/TagCategory';
import {MiniBookAdminService} from './mini-book-admin.service';

@Injectable({
  providedIn: 'root'
})
export class TagsPublicService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getTags(): Observable<Tag[]> {
    return this.http.get<any[]>(`${environment.url}${this.adminService.tenant}/tags`).pipe(
      map<any[], Tag[]>(data => data.map(value => Tag.createFromJson(value)))
    );
  }

  getTagCategories(): Observable<TagCategory[]> {
    return this.http.get<any[]>(`${environment.url}${this.adminService.tenant}/tagCategories`).pipe(
      map<any[], TagCategory[]>(data => data.map(value => TagCategory.createFromJson(value))),
      map(categories => categories.filter(category => category.tagIds.length > 0))

    );
  }
}
